import { AcceleratorBatch } from "../models/AcceleratorBatch";
import { BatchClassConfig } from "../models/config/BatchClassConfig";
import { sortBatches } from "../models/SweetListSorter";
import { AcceleratorBatchStore } from "../stores/impl/AcceleratorBatchStore";
import { AcceleratorDocMetadataStore } from "../stores/impl/AcceleratorDocMetadataStore";
import { AcceleratorDocModelStore } from "../stores/impl/AcceleratorDocModelStore";
import { pLimit } from "../utils/pLimit";
import { AcceleratorBatchDocumentLoader } from "./AcceleratorBatchDocumentLoader";
export { BatchService };
class BatchService {
  /**
   *
   * @param input BatchClassConfig or array of Batch Instance UUIDs
   * @param batchClassId
   * @returns
   */
  static async loadBatches(
    input: BatchClassConfig | string[],
    batchClassId: string,
  ): Promise<AcceleratorBatch[]> {
    if (Array.isArray(input)) {
      const accBatchPromises = AcceleratorBatchStore.getMany(input);
      accBatchPromises.forEach((p) => {
        p.then((accBatch) => {
          if (!accBatch) return;
          // TODO: test this happens when loading BatchInstances
          AcceleratorDocMetadataStore.setMany(
            accBatch.metadata.map((d) => {
              return d.updateDataFromBatchAndModelInfo(accBatch, batchClassId);
            }),
            true,
          );

          /* TODO: link acceleatorDocMetadata with Model, even though Model isn't close to being loaded.
           * current issues are
           * - AcceleratorDocModelStore handles all of this stuff.
           * - AcceleratorDocModelStore takes Model instead of ModelKey
           *      Mostly worked around, except setModel() and associate() requies a Model. This is fine for
           *          setModel(), but problematic as associate()'s method signature prevents us from using it.
           *      The remaining blocker is Unknown Models. For non-Unknown Models, the AcceleatorDocModelStore
           *          defers to ModelStore for persisting Model objects.
           *      For Unknown Models, as their storeId is inherently duplicated, we must support using a
           *          non-ModelStore backing to persist these Models.
           *      This could possibly be worked around if Models could only be modified once their name
           *          was set.
           *      To support Unknown Models not needing to be fully instantiated, and to avoid creating a
           *          new Map to persist our references, the UnknownModel Map will support both ModelStoreKeys
           *          AND Models. WIP idea, need to validate that the AcceleratorDocMetadata can consistently
           *          guess the Models storeKey
           *
           * - AcceleratorDocModelStores SAVES unknown Models directly.
           * - We know that the AcceleratorDoc will have a Model set again when it hydrates in
           *       AcceleratorBatchDocumentLoader.  TODO: test how that method handles existing entries
           */
          accBatch.metadata.map((d) => {
            return AcceleratorDocModelStore.associate(
              d.storeId,
              d.guessModelStoreKey(),
            );
          });
        });
      });
      const accBatches = await (
        await Promise.all(accBatchPromises)
      ).filter((x): x is AcceleratorBatch => x != undefined);
      // sort realAccDocs by batchInstanceUuid
      sortBatches(accBatches);
      // SweetListSorter.sort(accBatches,
      // (data) => `${data.batchInstanceId}${data.imported ? 1 : 0}`, 'BI', 16);
      // accBatches.reverse();

      return accBatches;
    }
    const uuids = await AcceleratorBatchStore.lookupBatchesByBatchClassId(
      input.batchClassId,
    );
    return BatchService.loadBatches(uuids, input.batchClassId);
  }
  /* Batches still need to be reloaded ! */
  static reprocess(
    acceleratorBatcheUuids: string[],
    concurrency: number = 5,
  ): Promise<boolean>[] {
    const limit = pLimit(concurrency);
    return acceleratorBatcheUuids.map((x) =>
      limit(() => AcceleratorBatchDocumentLoader.reprocess(x)),
    );
  }
  static delete(acceleratorBatcheUuids: string[]): Promise<boolean>[] {
    return acceleratorBatcheUuids.map((x) =>
      AcceleratorBatchDocumentLoader.delete(x),
    );
  }
}
